// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

interface Props {
    message?: string | null;
}

const NotFound: React.FC<Props> = ({ message }) => {
    const { t } = useTranslation();
    const displayMessage = message || t('notFoundPage.defaultMessage');

    return (
        <section className="space-ptb bg-holder">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-12 text-center">
                        <div className="error-404">
                            <h1>{t('notFoundPage.errorCode', '404')}</h1>
                            <strong>{displayMessage}</strong>
                            <Link
                                className="btn btn-primary"
                                title={t('navigation.homeLinkTitle') || 'Home'}
                                to="/"
                            >
                                {t('notFoundPage.backToHomeButton')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default NotFound;